/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import LocationType from '@linc-technologies/linced-common/enums/location-type';
import NSWSource from '@linc-technologies/linced-common/enums/nsw-source';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';
import SIFYesOrNo from '@linc-technologies/linced-common/enums/sif-yes-or-no';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';

export default class LocationEdit extends Component {
  Jurisdiction = Jurisdiction;
  LocationType = LocationType;
  NSWSource = NSWSource;
  NSWStatus = NSWStatus;
  SIFYesOrNo = SIFYesOrNo;

  @service
  session;

  location = null;
  close = null;
  saveAndClose = null;

  visibleStatuses = Object.freeze([
    { value: 1, label: 'Active' },
    { value: 2, label: 'Inactive' },
  ]);

  visibleYesOrNo = Object.freeze([
    { value: 0, label: 'Unknown' },
    { value: 2, label: 'No' },
    { value: 3, label: 'Yes' },
  ]);

  @computed('location.{name,description,size,capacity}')
  get isValid() {
    if (this.location === null) {
      return false;
    }
    if (this.location.name === '') {
      return false;
    }
    if (this.location.description === '') {
      return false;
    }
    if (this.location.size < 0) {
      return false;
    }
    if (this.location.capacity < 0) {
      return false;
    }
    return true;
  }

  @action
  setType(type) {
    this.location.set('type', type.value);
  }

  @action
  setStatus(status) {
    this.location.set('status', status.value);
  }

  @action
  setCanBeTimetabled(canBeTimetabled) {
    this.location.set('canBeTimetabled', canBeTimetabled.value);
  }
}
